import React, { FC } from 'react';

interface ILogoProps {
  width?: number;
  height?: number;
}

/**
 * Nike Swoosh Logo 组件
 */
const Logo: FC<ILogoProps> = ({ width = 100, height }) => {
  // 原始比例: 34:12
  const aspectRatio = 34 / 12;
  const calculatedHeight = height ?? width / aspectRatio;
  const calculatedWidth = height ? height * aspectRatio : width;

  return (
    <svg
      width={calculatedWidth}
      height={calculatedHeight}
      viewBox='0 0 34 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.224 6.518c-2.016.527-3.641.462-4.567-.209-2.374-1.756-.561-5.26.08-6.309-1.156 1.278-2.31 2.57-3.21 3.961-1.415 2.19-2.022 4.59-1.06 6.132 1.718 2.783 5.836 1.499 8.465.378L33.333.101 9.224 6.518z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  );
};

export default Logo;
